import React, { useState, useEffect, useContext } from 'react';
import firebase from "../../firebaseconfig";
import "firebase/auth";
import "firebase/firestore";

import UserListItem from '../../components/UserListItem';
import Loading from '../../components/Loading';
import Header from '../../containers/Header';

import { ListItemsContext } from '../../containers/context';
import { useHistory } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  list: {
    margin: 0,
    padding: 0,
  },
});

const UserPromoForms = () => {
  const classes = useStyles();

  const { promoForms } = useContext(ListItemsContext);
  const [userLogged, setUserLogged] = useState(null);
  const [userPromoForms, setUserPromoForms] = useState([]);
  let history = useHistory();
  
  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      setUserLogged(user.uid);
      const promoItem = [];
      promoForms.forEach((list) => {
        if(userLogged === list.user) {
          promoItem.push(list)
        }
      });
      setTimeout(() => {
        setUserPromoForms(promoItem);
      }, 1000);
    });
  }, [promoForms, userLogged])

  const handleListDetail = (listCode) => {
    history.push('/promo-form/' + listCode);
  }

  const handleRemoveList = (id) => {
    firebase
      .firestore()
      .collection("promoForm")
      .onSnapshot((snapshot) => {
        snapshot.forEach(doc => {
          if(doc.id === id) {
            doc.ref.delete();
          }
        });
    });
  }
  
  return (
    <>
      <Header />
      <Box mt={10}>
        { userPromoForms.length === 0 || userPromoForms === undefined
          ? <Loading />
          : <>
              <ul className={classes.list}>
                {userPromoForms.map((item) => <UserListItem key={item.id} listItem={item} onClick={() => handleListDetail(item.id)} onDeleteClick={() => handleRemoveList(item.id)}/>)}
              </ul>
            </>
        }
      </Box>
    </>
  );
}

export default UserPromoForms;